<template>
	<div class="status-page">
		<div class="bg-light">
			<app-header :nav="false" />
			<div class="container">
				<div class="page-content space-left">
					<header>
						<img src="images/ty-page/ty-success.png" alt="Sukces" />
						<h1>{{ cms.successHead }}</h1>
					</header>
					<p class="lead" v-html="cms.successSubHeadHtml"></p>
					<p v-html="cms.successTxtHtml"></p>
					<a href="//www.mforex.pl" class="btn btn-primary"
						>do strony głównej</a
					>
				</div>
			</div>
		</div>
		<status-page-footer />
	</div>
</template>

<script>
import AppHeader from '@/components/AppHeader';
import StatusPageFooter from '@/views/StatusPage/Partial/FooterView';

export default {
	data() {
		return {
			/* eslint-disable */
			cms: {
				successHead: SUCCESS_HEAD,
				successSubHeadHtml: SUCCESS_SUB_HEAD_HTML,
				successTxtHtml: SUCCESS_TXT_HTML,
			},
			/* eslint-enable */
		};
	},
	components: {
		AppHeader,
		StatusPageFooter,
	},
};
</script>
